import { render, staticRenderFns } from "./SwappResult.vue?vue&type=template&id=3c7363d8&scoped=true&"
import script from "./SwappResult.vue?vue&type=script&lang=js&"
export * from "./SwappResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7363d8",
  null
  
)

export default component.exports